module.exports = __webpack_public_path__ + "img/20_75.3696329c.png";